import React from "react";
import { Line } from "rc-progress";
import { withRouter } from "react-router-dom";

@withRouter
export default class LoaderBarContainer extends React.Component {
	tm = null;
	constructor(props) {
		super(props);
		this.state = {
			percent: 0,
		};
		this.increase = this.increase.bind(this);
		this.restart = this.restart.bind(this);
	}

	componentDidMount() {
		this.increase();
	}
	componentWillUnmount() {
		clearTimeout(this.tm);
	}

	increase() {
		const percent = this.state.percent + 1;
		if (percent >= 100) {
			clearTimeout(this.tm);
			return;
		}
		this.setState({ percent });
		this.tm = setTimeout(this.increase, 1);
	}

	restart() {
		clearTimeout(this.tm);
		this.setState({ percent: 0 }, () => {
			this.increase();
		});
	}
	componentDidUpdate(nextProps) {
		let { match, location, history } = this.props;
		if (nextProps.location.pathname != location.pathname) {
			this.restart();
		}
	}
	render() {
		if (this.state.percent == 99) {
			return null;
		}

		return (
			<Line
				className="progress-bar"
				percent={this.state.percent}
				strokeWidth={0.03}
				strokeColor="#5812fe"
			/>
		);
	}
}
